const slugs = {
  home: "/",
  explore: "/explore",
  inboxDetail: "/inbox/:id",
  inbox: "/inbox",
  live: "/live",
  accountVerify: "/account-verify",
  inviteCode: "/invite-code",
  depositEth: "/deposit-eth",
  profile: "/profile",
  activities: "/profile/activities/:id",
  profileBalance: "/profile-balance",
  otherProfile: "/profile/:id/",
  buyFirstShare: "/buy-first-share",
  upload: "/upload",
  point: "/point",
  login: "/login",
};

export default slugs;
